import { EmptyState } from '@/components/ui';

import { count, percent } from './format';

/**
 * A ranked list with a bar behind each row.
 *
 * The share the API sends is of the rows shown, not of everything -- these
 * lists are truncated -- so the heading says so rather than letting a reader
 * assume the percentages cover the whole population.
 */
export function SegmentList({ items = [], emptyLabel = 'Nothing to show yet', secondaryLabel }) {
  if (items.length === 0) {
    return <EmptyState title={emptyLabel} description="It fills in as applications arrive." />;
  }

  const widest = Math.max(...items.map((item) => item.count), 1);

  return (
    <ul className="space-y-2.5">
      {items.map((item) => (
        <li key={item.label}>
          <div className="mb-1 flex items-baseline justify-between gap-3 text-sm">
            <span className="text-ink truncate">{item.label}</span>
            <span className="text-ink-muted shrink-0 text-xs">
              {count(item.count)}
              {secondaryLabel && item.secondary != null && (
                <span className="ml-2">
                  {count(item.secondary)} {secondaryLabel}
                </span>
              )}
              {item.share != null && <span className="ml-2">{percent(item.share)}</span>}
            </span>
          </div>
          <div className="bg-surface-muted h-1.5 w-full overflow-hidden rounded-full">
            <div
              className="bg-brand-400 h-full rounded-full"
              style={{ width: `${(item.count / widest) * 100}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
